<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      :element-loading-text="$t('Please wait')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            $t("Product Management")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t("Price Management") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="form_container">
        <h1>{{ $t("Price Management") }}</h1>
        <div class="content_wrap">
          <div class="form_wrap">
            <!-- 中国 start -->
            <div class="block" v-if="COUNTRY.countryid == 1">
              <div class="block_item">
                <p>商品基础零售价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.yue_price"
                      placeholder="请输入基础零售价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.yue_price"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('yue_price', 'price', '越南盾')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品基础批发价（团批）价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.yue_tuan"
                      placeholder="请输入商品基础批发价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.yue_tuan"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('yue_tuan', 'groupprice', '越南盾')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品批发（团批）分销底价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.yue_tuan_base"
                      placeholder="请输入商品批发（团批）分销底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.yue_tuan_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('yue_tuan_base', 'pfprice', '越南盾')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 中国 end -->

            <!-- 越南 start -->
            <div class="block" v-if="COUNTRY.countryid == 4">
              <div class="block_item">
                <p>商品基础零售价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.yue_price"
                      placeholder="请输入基础零售价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.yue_price"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('yue_price', 'price', '越南盾')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品基础批发价（团批）价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.yue_tuan"
                      placeholder="请输入商品基础批发价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.yue_tuan"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('yue_tuan', 'groupprice', '越南盾')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品批发（团批）分销底价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.yue_tuan_base"
                      placeholder="请输入商品批发（团批）分销底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.yue_tuan_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('yue_tuan_base', 'pfprice', '越南盾')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 越南 end -->

            <!-- 泰国 start -->
            <div class="block" v-if="COUNTRY.countryid == 5">
              <div class="block_item" v-if="false">
                <p>泰铢零售底价</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.tai_price_base"
                      placeholder="铢零售底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.tai_price_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('tai_price_base', 'cbprice', '泰铢')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>

              <div class="block_item">
                <p>商品基础零售价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.tai_price"
                      placeholder="请输入基础零售价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.tai_price"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('tai_price', 'price', '泰铢')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品基础批发价（团批）价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.tai_tuan"
                      placeholder="请输入商品基础批发价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.tai_tuan"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('tai_tuan', 'groupprice', '泰铢')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品批发（团批）分销底价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.tai_tuan_base"
                      placeholder="请输入商品批发（团批）分销底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.tai_tuan_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('tai_tuan_base', 'pfprice', '泰铢')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 泰国 end -->

            <!-- 俄罗斯 start -->
            <div class="block" v-if="COUNTRY.countryid == 2">
              <div class="block_item" v-if="false">
                <p>卢布零售底价</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.lu_price_base"
                      placeholder="卢布零售底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.lu_price_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('lu_price_base', 'cbprice', '卢布')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>

              <div class="block_item">
                <p>商品基础零售价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.lu_price"
                      placeholder="请输入基础零售价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.lu_price"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('lu_price', 'price', '卢布')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品基础批发价（团批）价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.lu_tuan"
                      placeholder="请输入商品基础批发价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.lu_tuan"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('lu_tuan', 'groupprice', '卢布')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品批发（团批）分销底价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.lu_tuan_base"
                      placeholder="请输入商品批发（团批）分销底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.lu_tuan_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('lu_tuan_base', 'pfprice', '卢布')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 俄罗斯 start -->

            <!-- 加拿大 start -->
            <div class="block" v-if="COUNTRY.countryid == 6">
              <div class="block_item" v-if="false">
                <p>加拿大元零售底价</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.jia_price_base"
                      placeholder="加拿大元零售底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.jia_price_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('jia_price_base', 'cbprice', '加拿大元')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>

              <div class="block_item">
                <p>商品基础零售价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.jia_price"
                      placeholder="请输入基础零售价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.jia_price"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('jia_price', 'price', '加拿大元')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品基础批发价（团批）价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.jia_tuan"
                      placeholder="请输入商品基础批发价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.jia_tuan"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('jia_tuan', 'groupprice', '加拿大元')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品批发（团批）分销底价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.jia_tuan_base"
                      placeholder="请输入商品批发（团批）分销底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.jia_tuan_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('jia_tuan_base', 'pfprice', '加拿大元')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 加拿大 start -->

            <!-- 美国 start -->
            <div class="block" v-if="COUNTRY.countryid == 8">
              <div class="block_item" v-if="false">
                <p>美元零售底价</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.ame_price_base"
                      placeholder="美元零售底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.ame_price_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('ame_price_base', 'cbprice', '美元')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>

              <div class="block_item">
                <p>商品基础零售价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.ame_price"
                      placeholder="请输入基础零售价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.ame_price"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="handleUnitPrice('ame_price', 'price', '美元')"
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品基础批发价（团批）价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      v-model="formData.ame_tuan"
                      placeholder="请输入商品基础批发价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.ame_tuan"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('ame_tuan', 'groupprice', '美元')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="block_item">
                <p>商品批发（团批）分销底价（/件）</p>
                <div class="input_wrap flex-rowl">
                  <div class="input_box">
                    <el-input
                      type="number"
                      v-model="formData.ame_tuan_base"
                      placeholder="请输入商品批发（团批）分销底价"
                      :disabled="true"
                    ></el-input>
                  </div>
                  <span
                    class="copy_box"
                    :data-clipboard-text="formData.ame_tuan_base"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                  <div
                    class="price_edit"
                    @click="
                      handleUnitPrice('ame_tuan_base', 'pfprice', '美元')
                    "
                  >
                    <el-image
                      style="width: 20px; height: 20px"
                      :src="require('@/assets/images/price_edit_icon.png')"
                    ></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 美国 start -->
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="query">{{ $t("Confirm") }}</div>
        <div class="return_txt" @click="handleReturn">←{{ $t("Return") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, getCommidityDetail } from "../../../api/api";
import {
  getShopMultiPrice,
  addShopMultiPrice,
  editShopMultiPrice,
} from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import Clipboard from "clipboard";
import { mapState } from "vuex";
export default {
  name: "cMultiPrice",
  data() {
    return {
      loading: false,

      priceCustom: [
        // {
        //   type: "cbprice",
        //   text: "商品零售分销底价（/件）",
        //   original: "",
        //   inputValue: "",
        //   calculate: "",
        // },
        {
          type: "price",
          text: "商品基础零售价（/件）",
          original: "",
          inputValue: "",
          calculate: "",
        },
        {
          type: "groupprice",
          text: "商品基础批发价（团批）件（/件）",
          original: "",
          inputValue: "",
          calculate: "",
        },
        {
          type: "pfprice",
          text: "商品批发（团批）分销底价（/件）",
          original: "",
          inputValue: "",
          calculate: "",
        },
      ],
      formData: {
        cmid: "",
        yue_price_base: "",
        yue_tuan_base: "",
        yue_price: "",
        yue_tuan: "",
        tai_price_base: "",
        tai_tuan_base: "",
        tai_price: "",
        tai_tuan: "",
        lu_price_base: "",
        lu_tuan_base: "",
        lu_price: "",
        lu_tuan: "",
        jia_price_base: "",
        jia_tuan_base: "",
        jia_price: "",
        jia_tuan: "",
        ame_price_base: '',
        ame_tuan_base: '',
        ame_price: '',
        ame_tuan: '',
      },
      multiPriceDetail: "",
    };
  },
  directives: {
    "decimal-two": {
      bind(el) {
        el.addEventListener("input", function (e) {
          const input = e.target;
          const value = input.value;

          // 通过正则表达式验证输入是否符合要求
          const regex = /^\d+(\.\d{0,2})?$/;
          if (!regex.test(value)) {
            // 如果不符合要求，则截取小数点后两位
            const decimal = value.split(".");
            input.value =
              decimal.length > 1
                ? decimal[0] + "." + decimal[1].slice(0, 2)
                : decimal[0];
          }
        });
      },
    },
  },
  computed: {
    ...mapState(["COUNTRY", "USERINFO", 'COUNTRYLIST']),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.getShopMultiPrice();
        this.getDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 获取商品详情
    getDetail(id) {
      this.loading = false;
      let { priceCustom } = this;
      getCommidityDetail({ id }).then((res) => {
        this.detail = res;
        for (let i = 0; i < priceCustom.length; i++) {
          const type = priceCustom[i].type;
          let value = res[type];

          if (value === null || value === "") {
            value = 0;
          }
          priceCustom[i].original = value;
          priceCustom[i].calculate = value + 0; // 设置calculate属性为原始值加上0
        }
        this.loading = false;
      });
    },

    // 单独价格核算
    handleUnitPrice(name, type, text) {
      this.priceCustom.forEach((item) => {
        if (item.type == type) {
          this.formData[name] = this.convertCurrency(item.calculate, text);
        }
      });
    },
    // 计算汇率转换后的值
    convertCurrency(inputValue, currency) {
      let {countryExrateObj} = this.USERINFO
      if (
        currency == "韩元" ||
        currency == "越南盾" ||
        currency == "泰铢" ||
        currency == "日元" ||
        currency == "卢布"
      ) {
        return calculator(inputValue)
          .multiply(countryExrateObj.rate)
          .toNumber()
          .toFixed();
      } else {
        let num = calculator(inputValue).multiply(countryExrateObj.rate).toNumber();
        if (Number.isInteger(num)) {
          return num; // 如果是整数，直接返回
        } else {
          return num.toFixed(1); // 如果是小数，保留一位小数
        }
      }
    },

    // 获取多币种价格
    getShopMultiPrice() {
      getShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        this.multiPriceDetail = res;
        if (res.id) {
          // this.formData.yue_price_base = res.yue_price_base;
          this.formData.yue_tuan_base = res.yue_tuan_base;
          this.formData.yue_price = res.yue_price;
          this.formData.yue_tuan = res.yue_tuan;

          // this.formData.tai_price_base = res.tai_price_base;
          this.formData.tai_tuan_base = res.tai_tuan_base;
          this.formData.tai_price = res.tai_price;
          this.formData.tai_tuan = res.tai_tuan;

          // this.formData.lu_price_base = res.lu_price_base;
          this.formData.lu_tuan_base = res.lu_tuan_base;
          this.formData.lu_price = res.lu_price;
          this.formData.lu_tuan = res.lu_tuan;

          // this.formData.jia_price_base = res.jia_price_base;
          this.formData.jia_tuan_base = res.jia_tuan_base;
          this.formData.jia_price = res.jia_price;
          this.formData.jia_tuan = res.jia_tuan;

          this.formData.ame_tuan_base = res.ame_tuan_base;
          this.formData.ame_price = res.ame_price;
          this.formData.ame_tuan = res.ame_tuan;
        }
      });
    },
  
    handleReturn() {
      // history.back();
      this.$router.push({ name: "home" });
    },

    query() {
      let { formData, multiPriceDetail } = this;
      
      let params = formData;
      this.loading = true;
      if (multiPriceDetail.id) {
        editShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            this.loading = false;
            this.$message.success(
              res.message == "修改成功"
                ? this.$t("Modification successful")
                : res.message
            );
            // setTimeout(() => {
            //   this.loading = false;
            //   this.$router.back();
            // }, 500);
          } else {
            this.loading = false;
            this.$message.error(this.$t("Server Error"));
          }
        });
      } else {
        addShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            this.$message.success(
              res.message == "提交成功" ? "Gửi thành công" : res.message
            );
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(data.message || this.$t("Server Error"));
          }
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .exrate {
    margin-bottom: 20px;
    p {
      &:last-child {
        margin-top: 5px;
      }
    }
  }
  .form_container {
    height: 66vh;
  }
  .price_custom_wrap {
    margin: 30px 0;
    .tit {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .price_custom_content {
      .price_block {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .original {
          width: 290px;
        }
        .input_box {
          width: 200px;
          margin-right: 20px;
        }
      }
    }
  }
  .account_btn {
    display: inline-block;
    margin-bottom: 30px;
    padding: 0 20px;
    // width: 130px;
    height: 45px;
    background: #f62560;
    border: 1px solid rgba(173, 173, 173, 0.76);
    border-radius: 25px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
  .block_item {
    margin-bottom: 15px;
    .input_wrap {
      width: 100%;
      .input_box {
        flex: 1;
        margin-bottom: 0;
        /deep/ .el-input {
          &.is-disabled {
            .el-input__inner {
              background-color: #fff;
              color: #4f4e4e;
            }
          }
        }
      }
      .copy_box {
        cursor: pointer;
        width: auto;
        margin: 0 20px;
        .icon-fuzhi {
          font-size: 20px;
          color: #7d7d7d;
        }
      }
      .price_edit {
        cursor: pointer;
      }
    }
  }
}
</style>